import React from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react'
import { LayerGroup } from 'react-leaflet'
import { turfPointToLatLng } from 'utils'
import DrawingHandle from './DrawingHandle'
import LineDistance from './LineDistance'
import LineDrawingHandleList from './LineDrawingHandleList'
import OptionalGeoJSON from './OptionalGeoJSON'

// Represents a line:
//   * during drawing
//   * after drawing is complete but before "add" or "cancel" is clicked
// Renders the buffer region around the line, and during drawing,
// also renders a handle at each point in the line.
const LineLayer = ({ line }) => (
  line.drawing
    ? (
      <LayerGroup>
        {
          line.finalPoint !== null
            ? ([
              <DrawingHandle
                key='point'
                position={turfPointToLatLng(line.finalPoint)}
                inactive
                radius={6}
              />,
              <LineDistance
                key='distance'
                position={turfPointToLatLng(line.finalPoint)}
                text={line.lastTwoPointsDistance}
              />
              ])
            : null
        }
        <LineDrawingHandleList line={line} />
        <OptionalGeoJSON
          transparency={line.transparency}
          color={line.getColor}
          geoJSON={line.region}
          key={line.updatingRegion}
          className={classnames({
            'region-buffer': true,
            'region-buffer-too-large': line.tooLarge,
            'region-buffer-updating': line.updatingRegion,
            'region-buffer-user-drawn': true
          })}
        />
        <OptionalGeoJSON
          transparency={line.transparency}
          color={line.getColor}
          geoJSON={line.drawnLine}
          className='drawn-line'
        />
        <OptionalGeoJSON
          transparency={line.transparency}
          color={line.getColor}
          geoJSON={line.finalLine}
          className='drawn-line final-line'
          finalLine
        />
      </LayerGroup>
      )
    : (
      <LayerGroup>
        <OptionalGeoJSON
          transparency={line.transparency}
          color={line.getColor}
          geoJSON={line.region}
          key={line.updatingRegion}
          className={classnames({
            'region-buffer': true,
            'region-buffer-too-large': line.tooLarge,
            'region-buffer-updating': line.updatingRegion,
            'region-buffer-user-drawn': true
          })}
        />
        <OptionalGeoJSON
          transparency={line.transparency}
          color={line.getColor}
          geoJSON={line.drawnLine}
          className='drawn-line'
        />
      </LayerGroup>
      )
)

export default observer(LineLayer)
